function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import styled from 'styled-components';
import { setColor, setRem } from '../../../helpers/styleUtils';
import RoundedImage from "react-rounded-image";
import Div from "../htmlTags/Div";
const largeAvatarSize = 200;
const LargeDefaultAvatar = styled(Div)`
  width: ${setRem(largeAvatarSize)};
  height: ${setRem(largeAvatarSize)};
  line-height: ${setRem(largeAvatarSize)};
  font-size: ${setRem(largeAvatarSize * 0.6)};
  font-weight: normal;
  color: ${setColor.mountainMeadow};
  border-radius: 50%;
  border: ${setRem(2)} solid ${setColor.mountainMeadow};
  text-align: center;
`;
const smallAvatarSize = 80;
const SmallDefaultAvatar = styled(Div)`
  width: ${setRem(smallAvatarSize)};
  height: ${setRem(smallAvatarSize)};
  line-height: ${setRem(smallAvatarSize * 0.9)};
  font-size: ${setRem(smallAvatarSize * 0.5)};
  font-weight: bold;
  color: ${setColor.mountainMeadow};
  border-radius: 50%;
  border: ${setRem(2)} solid ${setColor.mountainMeadow};
  text-align: center;
`;
const thumbAvatarSize = 35;
const ThumbDefaultAvatar = styled(Div)`
  width: ${setRem(thumbAvatarSize)};
  height: ${setRem(thumbAvatarSize)};
  line-height: ${setRem(thumbAvatarSize * 0.9)};
  font-size: ${setRem(thumbAvatarSize * 0.5)};
  font-weight: bold;
  color: ${setColor.mountainMeadow};
  border-radius: 50%;
  border: ${setRem(2)} solid ${setColor.mountainMeadow};
  text-align: center;
`;
const tinyAvatarSize = 25;
const TinyDefaultAvatar = styled(Div)`
  width: ${setRem(tinyAvatarSize)};
  height: ${setRem(tinyAvatarSize)};
  line-height: ${setRem(tinyAvatarSize * 0.9)};
  font-size: ${setRem(tinyAvatarSize * 0.5)};
  font-weight: bold;
  color: ${setColor.scooter};
  border-radius: 50%;
  border: ${setRem(2)} solid ${setColor.scooter};
  text-align: center;
`;
const TinyRoundedImageWrapper = styled(Div)`
  display: inline-flex;
  vertical-align:top;
  padding-top: .2rem;
  min-width: 2rem;
`;

class Avatar extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "renderAvatarWithImage", () => {
      switch (this.props.size) {
        case 'large':
          return /*#__PURE__*/React.createElement(RoundedImage, {
            image: this.props.resource.avatarUrl,
            roundedSize: "0",
            roundedColor: 'transparent',
            imageWidth: largeAvatarSize,
            imageHeight: largeAvatarSize,
            cypress: this.props.cypress
          });

        case 'small':
          return /*#__PURE__*/React.createElement(RoundedImage, {
            image: this.props.resource.avatarUrl,
            roundedSize: "0",
            roundedColor: 'transparent',
            imageWidth: smallAvatarSize,
            imageHeight: smallAvatarSize,
            cypress: this.props.cypress
          });

        case 'thumb':
          return /*#__PURE__*/React.createElement(RoundedImage, {
            image: this.props.resource.avatarUrl,
            roundedSize: "0",
            roundedColor: 'transparent',
            imageWidth: thumbAvatarSize,
            imageHeight: thumbAvatarSize,
            cypress: this.props.cypress
          });

        case 'tiny':
          return /*#__PURE__*/React.createElement(TinyRoundedImageWrapper, null, /*#__PURE__*/React.createElement(RoundedImage, {
            image: this.props.resource.avatarUrl,
            roundedSize: "0",
            roundedColor: 'transparent',
            imageWidth: tinyAvatarSize,
            imageHeight: tinyAvatarSize,
            cypress: this.props.cypress
          }));

        default:
          return /*#__PURE__*/React.createElement(RoundedImage, {
            image: this.props.resource.avatarUrl,
            roundedSize: "0",
            roundedColor: 'transparent',
            imageWidth: thumbAvatarSize,
            imageHeight: thumbAvatarSize,
            cypress: this.props.cypress
          });
      }
    });

    _defineProperty(this, "renderDefaultAvatar", () => {
      const nameAbbr = this.props.resource.nameAbbr;

      switch (this.props.size) {
        case 'large':
          return /*#__PURE__*/React.createElement(LargeDefaultAvatar, {
            cypress: this.props.cypress
          }, nameAbbr);

        case 'small':
          return /*#__PURE__*/React.createElement(SmallDefaultAvatar, {
            cypress: this.props.cypress
          }, nameAbbr);

        case 'thumb':
          return /*#__PURE__*/React.createElement(ThumbDefaultAvatar, {
            cypress: this.props.cypress
          }, nameAbbr);

        case 'tiny':
          return /*#__PURE__*/React.createElement(TinyRoundedImageWrapper, null, /*#__PURE__*/React.createElement(TinyDefaultAvatar, {
            cypress: this.props.cypress
          }, nameAbbr));

        default:
          return /*#__PURE__*/React.createElement(ThumbDefaultAvatar, {
            cypress: this.props.cypress
          }, nameAbbr);
      }
    });

    _defineProperty(this, "renderAvatar", () => {
      return !!this.props.resource.avatarUrl ? this.renderAvatarWithImage() : this.renderDefaultAvatar();
    });

    _defineProperty(this, "render", () => {
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.renderAvatar());
    });
  }

}

export default Avatar;